var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getCurrentScene, updateScene } from "../../redux/actions/canvas/canvas";
import { clone } from "../../utils/clone";
export var MAX_HISTORY_SIZE = 15;
/**
 * Добавляет команду в историю текущей сцены
 */
export var addCommand = function (type, data) {
    var scene = getCurrentScene();
    if (scene) {
        var command = {
            type: type,
            data: clone(data),
            timestamp: Date.now()
        };
        // Инициализируем массив команд, если его нет
        if (!scene.history) {
            scene.history = [];
        }
        // Добавляем команду
        scene.history.push(command);
        console.log("\u041A\u043E\u043C\u0430\u043D\u0434\u0430 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0430: ".concat(type, ", \u0438\u0441\u0442\u043E\u0440\u0438\u044F \u0434\u043B\u0438\u043D\u0430: ").concat(scene.history.length));
        // Ограничиваем размер истории
        if (scene.history.length > MAX_HISTORY_SIZE) {
            scene.history.shift(); // удаляем самую старую команду
        }
        updateScene(scene);
    }
};
/**
 * Выполняет откат последней команды
 */
export var undoLastCommand = function () {
    var _a, _b;
    var scene = getCurrentScene();
    if (!scene || !scene.history || scene.history.length === 0) {
        console.log('История пуста или сцена не найдена');
        return;
    }
    var command = scene.history.pop();
    console.log('Откат команды:', command.type, 'Данные:', command.data);
    console.log('Элементов до отката - curves:', scene.curves.length, 'lines:', scene.lines.length, 'images:', scene.images.length, 'notes:', scene.notes.length, 'shapes:', ((_a = scene.shapes) === null || _a === void 0 ? void 0 : _a.length) || 0);
    if (command) {
        executeUndo(scene, command);
        console.log('Элементов после отката - curves:', scene.curves.length, 'lines:', scene.lines.length, 'images:', scene.images.length, 'notes:', scene.notes.length, 'shapes:', ((_b = scene.shapes) === null || _b === void 0 ? void 0 : _b.length) || 0);
        updateScene(scene);
    }
};
/**
 * Выполняет откат конкретной команды
 */
var executeUndo = function (scene, command) {
    switch (command.type) {
        case 'ADD_CURVE':
            // Удаляем последнюю добавленную кривую
            scene.curves = scene.curves.filter(function (curve) { return curve.id !== command.data.id; });
            break;
        case 'ADD_LINE':
            // Удаляем последнюю добавленную линию
            scene.lines = scene.lines.filter(function (line) { return line.id !== command.data.id; });
            break;
        case 'ADD_IMAGE':
            // Удаляем добавленное изображение
            scene.images = scene.images.filter(function (img) { return img.id !== command.data.id; });
            break;
        case 'ADD_NOTE':
            // Удаляем добавленную заметку
            scene.notes = scene.notes.filter(function (note) { return note.id !== command.data.id; });
            break;
        case 'ADD_SHAPE':
            // Удаляем последнюю добавленную фигуру
            scene.shapes = scene.shapes.filter(function (shape) { return shape.id !== command.data.id; });
            break;
        case 'DELETE_ITEMS':
            // Восстанавливаем удаленные элементы
            var _a = command.data.deletedItems, _b = _a.curves, curves = _b === void 0 ? [] : _b, _c = _a.lines, lines = _c === void 0 ? [] : _c, _d = _a.images, images = _d === void 0 ? [] : _d, _e = _a.notes, notes = _e === void 0 ? [] : _e, _f = _a.shapes, shapes = _f === void 0 ? [] : _f;
            console.log('Восстанавливаем удаленные элементы:', {
                curves: curves.length,
                lines: lines.length,
                images: images.length,
                notes: notes.length,
                shapes: shapes.length
            });
            console.log('Детали восстанавливаемых линий:', lines);
            scene.curves = __spreadArray(__spreadArray([], __read(scene.curves), false), __read(curves), false);
            scene.lines = __spreadArray(__spreadArray([], __read(scene.lines), false), __read(lines), false);
            scene.images = __spreadArray(__spreadArray([], __read(scene.images), false), __read(images), false);
            scene.notes = __spreadArray(__spreadArray([], __read(scene.notes), false), __read(notes), false);
            scene.shapes = __spreadArray(__spreadArray([], __read(scene.shapes), false), __read(shapes), false);
            break;
        case 'MOVE_IMAGE':
            // Возвращаем изображение на предыдущую позицию
            scene.images = scene.images.map(function (img) {
                if (img.id === command.data.id) {
                    return __assign(__assign({}, img), { x: command.data.oldX, y: command.data.oldY });
                }
                return img;
            });
            break;
        case 'MOVE_NOTE':
            // Возвращаем заметку на предыдущую позицию
            scene.notes = scene.notes.map(function (note) {
                if (note.id === command.data.id) {
                    return __assign(__assign({}, note), { points: [command.data.oldX, command.data.oldY] });
                }
                return note;
            });
            break;
        case 'MOVE_VOICE_RECORDER':
            // Возвращаем диктофон на предыдущую позицию
            scene.voiceRecords = scene.voiceRecords.map(function (record) {
                if (record.id === command.data.id) {
                    return __assign(__assign({}, record), { x: command.data.oldX, y: command.data.oldY });
                }
                return record;
            });
            break;
        case 'MOVE_SHAPE':
            // Возвращаем фигуру на предыдущую позицию
            scene.shapes = scene.shapes.map(function (shape) {
                if (shape.id === command.data.id) {
                    return __assign(__assign({}, shape), { x: command.data.oldX, y: command.data.oldY });
                }
                return shape;
            });
            break;
        case 'TRANSFORM_IMAGE':
            // Возвращаем предыдущие параметры трансформации изображения
            scene.images = scene.images.map(function (img) {
                if (img.id === command.data.id) {
                    return __assign(__assign({}, img), { rotation: command.data.oldRotation, scaleX: command.data.oldScaleX, scaleY: command.data.oldScaleY, height: command.data.oldHeight, width: command.data.oldWidth });
                }
                return img;
            });
            break;
        case 'TRANSFORM_NOTE':
            // Возвращаем предыдущие параметры трансформации заметки
            scene.notes = scene.notes.map(function (note) {
                if (note.id === command.data.id) {
                    return __assign(__assign({}, note), { rotation: command.data.oldRotation, height: command.data.oldHeight, width: command.data.oldWidth });
                }
                return note;
            });
            break;
        case 'TRANSFORM_SHAPE':
            // Возвращаем предыдущие параметры трансформации фигуры
            scene.shapes = scene.shapes.map(function (shape) {
                if (shape.id === command.data.id) {
                    return __assign(__assign({}, shape), { rotation: command.data.oldRotation, scaleX: command.data.oldScaleX, scaleY: command.data.oldScaleY });
                }
                return shape;
            });
            break;
        case 'UPDATE_NOTE_CONTENT':
            // Возвращаем предыдущий контент заметки
            scene.notes = scene.notes.map(function (note) {
                if (note.id === command.data.id) {
                    return __assign(__assign({}, note), { content: command.data.oldContent });
                }
                return note;
            });
            break;
        case 'PASTE_IMAGE':
            // Удаляем вставленное изображение
            scene.images = scene.images.filter(function (img) { return img.id !== command.data.id; });
            break;
        default:
            console.warn("Unknown command type: ".concat(command.type));
    }
};
